import { DialogBoxData, DialogBoxService, DialogBoxType } from 'dialog-box';
import { Component } from '@angular/core';
import { EventManagerService } from 'event-manager';
import { ModalBoxService } from 'modal-box';
import { WincoEvents } from 'src/app/enums/winco-events..enum';
import { ReplayAnalyzerRequestData } from 'src/app/models/winco/laparoscopy-analysis-result.model';
import { ReplayService } from 'src/app/services/replay.service';

@Component({
  selector: 'app-replay-analyzer',
  templateUrl: './replay-analyzer.component.html',
  styleUrl: './replay-analyzer.component.scss'
})
export class ReplayAnalyzerComponent
{
  waiting = true;
  processing = false;

  constructor(private modalBoxService: ModalBoxService,
              private replayService:ReplayService,
              private dialogService:DialogBoxService,
              private eventManagerService:EventManagerService)
  {}

  analyze()
  {
    this.waiting = false;
    this.processing = true;

    const request = this.modalBoxService.data as ReplayAnalyzerRequestData;
    const uuid = request?.uuid;
    const score = request?.score ?? null;

    this.replayService.AnalyzeVideo(uuid).then(response =>
    {
      this.processing = false;

      this.close();
      this.replayService.viewAnalysis(response, score);
      this.eventManagerService.emitEvent(WincoEvents.IA_ANALIZED, { uuid, response });
    })
    .catch(err =>
    {
      this.close();

      if(typeof(err) === 'string')
      {
        this.dialogService.show(new DialogBoxData({
          type: DialogBoxType.ALERT,
          message: err
        }));
      }
    });
  }

  close()
  {
    this.modalBoxService.hide();
  }
}
